export const AsyncResource = null;
export const createHook = null;
export const fork = null;
export const Worker = null;
export const createServer = null;
export const connect = null;
export const fileURLToPath = (url) => url.replace(/^.*?:\/\//, "");
